<script lang="ts">
  import { onMount } from "svelte";
  import { link } from "svelte-spa-router";
  import { confirmEmailChange } from "../lib/api";
  import { _ } from "../lib/i18n";

  /** Route params injected by svelte-spa-router: { token }. */
  export let params: { token?: string } = {};

  let state: "loading" | "ok" | "fail" = "loading";

  onMount(async () => {
    const token = params.token ?? "";
    if (!token) {
      state = "fail";
      return;
    }
    try {
      await confirmEmailChange(token);
      state = "ok";
    } catch {
      state = "fail";
    }
  });
</script>

<section class="login">
  <div class="card">
    <h1>{$_("confirmEmail.title")}</h1>
    {#if state === "loading"}
      <p class="sub" data-testid="confirm-email-loading">
        {$_("confirmEmail.loading")}
      </p>
    {:else if state === "ok"}
      <p class="sub ok" data-testid="confirm-email-ok">{$_("confirmEmail.ok")}</p>
      <a class="forgot" href="/" use:link>{$_("account.back")}</a>
    {:else}
      <p class="sub error" data-testid="confirm-email-fail">
        {$_("confirmEmail.fail")}
      </p>
      <a class="forgot" href="/" use:link>{$_("account.back")}</a>
    {/if}
  </div>
</section>

<style>
  .login {
    min-height: 100vh;
    display: grid;
    place-items: center;
    padding: 1rem;
    /* iOS viewport-fit=cover: keep the card out from under the status bar and
       home indicator. env() is 0 elsewhere, so 1rem is preserved. */
    padding-top: max(1rem, env(safe-area-inset-top));
    padding-bottom: max(1rem, env(safe-area-inset-bottom));
  }
  .card {
    width: 100%;
    max-width: 360px;
    background: #111827;
    border: 1px solid #374151;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  }
  h1 {
    margin: 0 0 0.25rem;
    font-size: 1.5rem;
  }
  .sub {
    margin: 0 0 1rem;
    color: #9ca3af;
  }
  .ok {
    color: #6ee7b7;
  }
  .error {
    color: #fca5a5;
  }
  .forgot {
    display: inline-block;
    color: #6ee7b7;
    font-size: 0.85rem;
    text-decoration: none;
  }
  .forgot:hover {
    text-decoration: underline;
  }
</style>
